import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAppDispatch, useAppSelector } from "@redux/hooks";
import { retrievePublicStudios } from "@academy-context/read/application/use-cases/shared/studios-retrieval/retrieve-public-studios";
import { selectPublicStudiosRetrieval } from "@academy-context/read/application/use-cases/shared/studios-retrieval/selectors/public-studios-selectors";
import { selectTeacherOnboarding } from "@user-management-context/write/application/use-cases/teacher-onboarding/selectors/teacher-onboarding-selectors";
import { selectDocumentUpload } from "@shared-kernel/application/use-cases/document-upload/selectors/document-upload-selectors";
import { TeacherOnboarding } from "./teacher-onboarding.content";
import { useTeacherOnboarding } from "./use-teacher-onboarding";
import { fullSchema, type TeacherOnboardingFormInputs } from "./form-validation/full-form.schema";
import { defaultValues } from "./form-validation/shared";

export const TeacherOnboardingContainer = () => {
  const dispatch = useAppDispatch();
  const { processing } = useAppSelector(selectTeacherOnboarding);
  const { processing: uploadProcessing } = useAppSelector(selectDocumentUpload);
  const { data: publicStudios } = useAppSelector(selectPublicStudiosRetrieval);

  useEffect(() => {
    dispatch(retrievePublicStudios());
  }, [dispatch]);

  const form = useForm<TeacherOnboardingFormInputs>({ resolver: yupResolver(fullSchema), defaultValues, mode: "onSubmit" });
  const { onboard, uploadResume, uploadMethodologyDocument } = useTeacherOnboarding(form);

  return (
    <TeacherOnboarding
      form={form}
      publicStudios={publicStudios ?? []}
      onSubmit={form.handleSubmit(onboard)}
      submitting={processing === "pending"}
      onUploadResume={uploadResume}
      onUploadMethodology={uploadMethodologyDocument}
      uploadProcessing={uploadProcessing}
    />
  );
};
